
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Edit, Trash2 } from "lucide-react";
import { BlogCategory } from "@/types/blogPost";

interface CategoryListProps {
  categories: BlogCategory[];
  onEdit: (category: BlogCategory) => void;
  onDelete: (categoryId: string) => void;
}

export function CategoryList({ categories, onEdit, onDelete }: CategoryListProps) {
  const handleDelete = (categoryId: string) => {
    if (confirm("Tem certeza que deseja excluir esta categoria?")) {
      onDelete(categoryId);
    }
  };

  return (
    <div className="space-y-3">
      {categories.map((category) => (
        <Card key={category.id}>
          <CardContent className="p-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <Badge 
                  style={{ 
                    backgroundColor: category.color_hex,
                    borderColor: category.border_color_hex,
                    color: category.text_color_hex
                  }}
                  className="border"
                >
                  {category.name}
                </Badge>
                <div className="flex gap-2">
                  <div 
                    className="w-6 h-6 rounded border"
                    style={{ backgroundColor: category.color_hex, borderColor: category.border_color_hex }}
                    title={`Cores: ${category.color_hex} / ${category.border_color_hex} / ${category.text_color_hex}`}
                  />
                  <span className="text-sm text-gray-500">
                    {category.color_hex} / {category.border_color_hex} / {category.text_color_hex}
                  </span>
                </div>
              </div>
              <div className="flex gap-2">
                <Button
                  onClick={() => onEdit(category)}
                  size="sm"
                  variant="outline"
                >
                  <Edit className="w-4 h-4" />
                </Button>
                <Button
                  onClick={() => handleDelete(category.id)}
                  size="sm"
                  variant="destructive"
                >
                  <Trash2 className="w-4 h-4" />
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
